module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_04.aa744449.jpg";